
<app-data-table
  [columns]="cols"
  [data]="system"
  [totalRecords]="totalRecords"
  [isCardView]="false"
  [url]="'/transaction/legacy/data/'"

  [isDeletable]="true"
  [showAddButton]="true"
  [isEditable]="true"
  [isView]="false"
  [editingRowId]="editingRowId"
  [title]="title"
  (onAdd)="openModal()"
  (editEventRow)="updateSystem($event)"
  (deleteEventRow)="showDeletePopup($event)">
</app-data-table>


<!-- ✅ IMPORT MODAL -->
<div class="custom-modal" *ngIf="showModal">
  <div class="overlay" (click)="closeModal()"></div>

  <div class="modal-box">
 <div class="d-flex justify-content-between align-items-center mb-3">
       <h5 class="mb-3">Import Legacy Data</h5>

      <span class="close-icon" (click)="closeEditModal()">✕</span>
    </div>
    <!-- HEADER -->
   <div class="alert alert-dark" *ngIf="importMessage">
  <span class="fw-bold text-danger">Note**</span>
  <span class="text-danger"> {{ importMessage }}</span>
</div>

    <!-- FILE UPLOAD -->
 <div class="row mb-3">

  <!-- CSV Upload -->
  <div class="col-md-6">

    <div class="d-flex align-items-center mb-1">
      <label class="form-label mb-0 me-2">
        Upload CSV <span class="text-danger">*</span>
      </label>

      <a 
        href="https://iima-api.ilizien-projects-cdf.in/media/sample_csv/legacy.csv"
        target="_blank"
        class="text-primary text-decoration-underline small">
        Download Sample CSV
      </a>
    </div>

    <input 
      type="file" 
      class="form-control" 
      required
      (change)="onCSVUpload($event)" />

  </div>

  <!-- ZIP Upload -->
  <div class="col-md-6">

    <label class="form-label">
      Upload ZIP <span class="text-danger">*</span>
    </label>

    <input 
      type="file" 
      class="form-control"
      required
      (change)="onZIPUpload($event)" />

  </div>

</div>

    <!-- ACTION BUTTON -->
    <div class="d-flex justify-content-end mb-3">
      <button class="btn btn-secondary me-2" (click)="closeModal()">Cancel</button>
      <button class="btn btn-success"
        [disabled]="!csvFile || !zipFile"
        (click)="importData()">Save</button>
    </div>

    <!-- SCROLL CONTENT -->
    <div class="instruction-section">

  <!-- GUIDELINES -->
  <div class="info-box">
    <h6>Guidelines for File Upload</h6>
    <ul>
      <li><b>Name</b> is mandatory for every row, must be unique, and follow briefcase naming conventions (no special characters except <code>_</code> or <code>-</code>).</li>
      <li>Each <b>Name</b> field will act as the primary identifier for proposals.</li>
      <li>Ensure case-sensitive match between CSV <b>Name</b> and folder names in the zipped briefcase.</li>
      <li>Each folder must contain at least one document and include all relevant proposal documents.</li>
      <li>Each <b>Name</b> field will act as the primary identifier for proposals.</li>
      <li>Each <b>Scheme</b> must be selected from predefined schemes: <code>TDF, MAKE 1, MAKE 2, MAKE 3, IDEX ADITI, IDEX DISC, IDEX OC, IDEX 4Fauji, IDEX Prime,IDEX INDUS-X, REVENUE  </code>.</li>
      <li><b>Start Date</b> / <b>End Date</b> must follow the format <code>DD-MM-YYYY</code>. <b>End Date</b> must be greater than or equal to <b>Start Date</b>.</li>
    </ul>
  </div>

  <!-- SAMPLE CSV -->
  <div class="sample-box">
    <h6>Sample CSV File Structure</h6>

    <div class="table-responsive">
      <table class="table table-bordered table-sm">
        <thead class="table-light">
          <tr>
            <th>Ser</th>
            <th>Name</th>
            <th>Description</th>
            <th>Scheme</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Nodal Dte</th>
            <th>Nodal Officer</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>1</td>
            <td>Revenue_OpenTender_2025</td>
            <td>Annual revenue tender</td>
            <td>REVENUE </td>
            <td>01-04-2026</td>
            <td>31-03-2027</td>
            <td>DSP</td>
            <td>John Doe</td>
          </tr>
          <tr>
            <td>2</td>
            <td>MAKE1_Proposal_Alpha</td>
            <td>Proposal for new initiative</td>
            <td>MAKE 1 </td>
            <td>15-04-2026</td>
            <td>14-04-2027</td>
            <td>DME </td>
            <td>Jane Smith</td>
          </tr>
        </tbody>
      </table>
    </div>

    <small class="text-muted">* Mandatory fields</small>
  </div>

  <!-- ZIP STRUCTURE -->
  <div class="sample-box">
    <h6>Sample Briefcase Zipped Folder Structure</h6>

<pre class="folder-structure">
briefcase_folder.zip
 ├── Revenue_OpenTender_2025/
 │    ├── RFP.pdf
 │    ├── SOTR.docx
 │    └── Proposal_Details.xlsx
 └── MAKE1_Proposal_Alpha/
      ├── Approval_Note.pdf
      ├── Technical_Document.docx
</pre>

    <p class="note">
      Folder names must exactly match the <b>Name</b> field in the CSV (case-sensitive). Each folder must contain at least one document relevant to the proposal.
    </p>

  </div>

</div>

  </div>
</div>

<div class="custom-modal" *ngIf="showEditModal">
  <div class="overlay" (click)="closeEditModal()"></div>

  <div class="modal-box">

    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="m-0">Edit Legacy Data</h5>

      <span class="close-icon" (click)="closeEditModal()">✕</span>
    </div>

    <div class="row">

      <div class="col-md-6 mb-2">
        <label>Proposal Name</label>
        <input type="text" class="form-control" [(ngModel)]="selectedRow.name">
      </div>

      <div class="col-md-6 mb-2">
        <label>Scheme Name</label>
        <input type="text" class="form-control" [(ngModel)]="selectedRow.scheme_name">
      </div>

      <div class="col-md-6 mb-2">
        <label>Nodal Directorate</label>
        <input type="text" class="form-control" [(ngModel)]="selectedRow.nodal_directorate">
      </div>

      <div class="col-md-6 mb-2">
        <label>Start Date</label>
        <input type="date" class="form-control" [(ngModel)]="selectedRow.start_date">
      </div>

      <div class="col-md-6 mb-2">
        <label>End Date</label>
        <input type="date" class="form-control" [(ngModel)]="selectedRow.end_date">
      </div>

    </div>

    <div class="text-end mt-3">
      <button class="btn btn-secondary me-2" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" (click)="updateLegacy()">Update</button>
    </div>

  </div>
</div>
